import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { HierarchyNode, SourceSystem } from '#models';

@Injectable({ providedIn: 'root' })
export class ReferenceDataService {
  private _http = inject(HttpClient);
  private _base = `${environment.apiBaseUrl}/v1/reference-data`;

  getHierarchyNodes(sourceSystem?: string, type?: string): Observable<HierarchyNode[]> {
    const params: Record<string, string> = {};
    if (sourceSystem) params['sourceSystem'] = sourceSystem;
    if (type) params['type'] = type;
    return this._http.get<HierarchyNode[]>(`${this._base}/hierarchy`, { params });
  }

  getHierarchyChildren(parentId: number): Observable<HierarchyNode[]> {
    return this._http.get<HierarchyNode[]>(`${this._base}/hierarchy/children/${parentId}`);
  }

  getSourceSystems(): Observable<SourceSystem[]> {
    return this._http.get<SourceSystem[]>(`${this._base}/hierarchy/source-systems`);
  }
}
